import React from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { AxiosError } from 'axios';
import Form, { IFormInput } from '../Form';
import ProfileTemplate from '../ProfileTemplate';
import { useApiKeys } from '../../hooks';

export default function AddApiKey() {
  const formHook = useForm();
  const { setError } = formHook;

  const history = useHistory();
  const { addApiKey } = useApiKeys();

  const inputs: IFormInput[] = [
    {
      name: 'name',
      label: 'API Key Name',
      required: true
    },
    {
      name: 'description',
      label: 'Description'
    }
  ];

  const onSubmit = (data: any) => {
    addApiKey(data)
      .then(response => history.push(`/status/${response.data.id}`))
      .catch(processError);
  };

  function processError(error: AxiosError) {
    const { response } = error;

    if (response?.status === 409) {
      const { field } = response.data;

      setError(field, {
        message: 'apiKyeIsAlreadyUsed'
      });

      return;
    }
  }

  return <ProfileTemplate className="add-api-key">
    <div className="d-flex justify-content-center">
      <Form className="w-50" inputs={inputs} onSubmit={onSubmit} submitCaption="Add API Key" formHook={formHook} />
    </div>
  </ProfileTemplate>
}